import React from 'react';
import useUrlParams from '../../../../hooks/useUrlParams';
import person from '../../../../images/person.jpg';
import { useTranslation } from 'react-i18next';

const RenderSellerInfo = ({ employee, isAvatar }) => {
  const { t } = useTranslation();
  const { baseUrl } = useUrlParams();
  const baseUrlBeforeAjax = baseUrl.split('/ajax')[0].replace(/\/[a-z]{2,3}$/, '');

  const imageUrl = employee?.avatar ? `${baseUrlBeforeAjax}/${employee.avatar}` : person;
  return (
    <div className="d-flex align-items-center">
      {isAvatar &&
        <div className='me-2'>
          <img
            className="img-employ-list rounded-circle d-flex"
            src={imageUrl} alt="Avatar" width="40px" height="40px"
          />
        </div>
      }
      <div className='d-flex flex-column'>
        <span className="text-dark text-decoration-none">
           {employee?.fullName}
        </span>
        <span className="text-info fs-7">
         {t('salesStatistics.Seller')}
        </span>
      </div>
    </div>
  );
};

export default RenderSellerInfo;